import React from "react";
import { useDispatch } from "react-redux";
import TemplateLayout from "../../../../../providers/TemplateLayout";
import { setTemplateText } from "../../../../../store/slices/endorsement.slice";
import { useAppSelector } from "../../../../../hooks/app";
import { getUser } from "../../../../../store/slices/auth-slice";
import { ROLES } from "../../../../../constants";

function SoloFlightThree({ templateName }: { templateName: string }) {
  const user = useAppSelector(getUser)
  const [name, setName] = React.useState(user?.role === ROLES.STUDENT ? user?.firstname + " " + user?.lastname : '')
  const [landingLocation, setLandingLocation] = React.useState("");
  const [conditions, setConditions] = React.useState("");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const templateText = `I certified that ${name} has received the required training of §61.93(b)(1). I have determined that [he or she] is proficient to practice solo takeoffs and landings at ${landingLocation} are subject to the following conditions: ${conditions}`;
    dispatch(setTemplateText(templateText));
  }, [name, landingLocation, conditions, dispatch]);

  return (
    <TemplateLayout templateName={templateName}>
      <div className="col-12 my-2">
        <label>Relevant FAR: 61.101(b)</label>
      </div>

      <div className="col-12 my-2">
        <p className="certificate_text" style={{ margin: 0 }}>
          I certified that <input type="text" onChange={(e) => setName(e.target.value)} value={name} /> has received the required training of §61.93(b)(1). I have determined that [he or she] is proficient to practice solo takeoffs and landings at
          <input
            type="text"
            onChange={(e) => setLandingLocation(e.target.value)}
            placeholder="location"
            style={{ margin: '0 5px' }}
          />
          are subject to the following conditions:
          <input
            type="text"
            onChange={(e) => setConditions(e.target.value)}
            className="input_long"
            style={{ margin: '0 5px' }}
          />
        </p>
      </div>
    </TemplateLayout>
  );
}

export default SoloFlightThree;
